/**
 * مصدر الحقيقة الوحيد لمعرّف Google Ads في كود المتصفّح.
 * ⚠️ ممنوع قراءة `VITE_GOOGLE_ADS_ID` مباشرةً في أيّ ملفّ آخر.
 */
export const GOOGLE_ADS_ID =
  (import.meta.env.VITE_GOOGLE_ADS_ID as string | undefined) || null;
